import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $types } from './Ultraship.types'

@Injectable({ providedIn: 'root' })
export class Ultraship_main_get_and_process_ultraship_documents_from_sftpService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { ftpWorkingFolder?: string, ftpArchiveFolder?: string, ftpErroFolder?: string, ftpFileExtension?: string }): Promise<{ debugDetails?: string[], outputDetails?: string[] }> 
  {
    let url = `${environment.backendUrl}api/Ultraship/functions/main_get_and_process_ultraship_documents_from_sftp`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}

